<!-- TABLE & CONTROLS -->
<div
  [class.apply-datatable-fullscreen-styles]='!cService.isDarkTheme && cService.elementIsFullscreen'
  [class.overflow-all-auto]='cService.elementIsFullscreen'
  fxLayout='column'
  fxFill
>
  <div
    class='add-entity'
    *ngIf="cContentService.currentContentType && metadata?.operations && metadata?.operations.includes('add')"
  >
    <mat-toolbar class='mini-header force' fxLayout='row' fxLayoutAlign='end center'>
      <button mat-button (click)='onAddEntity()' vrm-button style='color: white; margin-right: 10px'>
				<span *ngIf='cContentService.currentContentType === cContentService.contentTypes.notifications'>
					{{ 'CUSTOM_CONTENT.addNotification' | translate | uppercase }}
				</span>

        <span *ngIf='cContentService.currentContentType === cContentService.contentTypes.tooltips'>
					{{ 'CUSTOM_CONTENT.newContent' | translate | uppercase }}
				</span>
      </button>
    </mat-toolbar>
  </div>
  <div *ngIf='canAddElement'>
    <mat-toolbar class='mini-header force'>
      <div class='stretch page-title' style='text-align: right'>
        <button
          *ngIf='canAddElement'
          mat-button
          (click)='onAddElement()'
          style='color: white; margin: 0 5px 0 5px'
          [style.background-color]="'#' + cService.userProfile?.HqColour"
        >
          {{ 'GENERIC.addElement' | translate | uppercase }}
        </button>
        <button
          *ngIf='canUploadElements'
          mat-button
          (click)='onUploadElements()'
          style='color: white; margin: 0 5px 0 5px'
          [style.background-color]="'#' + cService.userProfile?.HqColour"
        >
          {{ 'GENERIC.uploadElements' | translate | uppercase }}
          <mat-icon class='material-icons-outlined' [style.color]="'white'">cloud_upload</mat-icon>
        </button>

        <button
          mat-button
          (click)='triggerOutputAction()'
          style='color: white; margin: 0 5px 0 5px'
          [style.background-color]="'#' + cService.userProfile?.HqColour"
        >
          {{ getOutputActionName() | translate | uppercase }}
        </button>
      </div>
    </mat-toolbar>
  </div>

  <!-- Child report navigation controls -->
  <report-data-multi-nav></report-data-multi-nav>
  <vrm-report-data-nav></vrm-report-data-nav>

  <!-- Report information / message -->
  <div
    *ngIf='reportHasInformation'
    class='no-elevation-but-underline mini-header-style subtle-border'
    style='padding-top: 20px; padding-bottom: 20px; padding-left: 35px; padding-right: 35px'
    [matTooltip]="
			!cService.isMobileViewport && reportInformation?.notification
				? ''
				: (reportInformation.notification | translate)
		"
  >
    <small class='grid-header-text-color bold' fxFlex [class.very-small-text]='cService.isMobileViewport'>
      <span *ngIf='reportInformation.notification'>{{ reportInformation.notification }}</span>

      <ng-container *ngIf='reportInformation.recommendationsReport'>
				<span *ngIf='reportInformation.recommendationsReport.dates' style='display: block'>
					<span *ngIf='!reportInformation.recommendationsReport.dates.generated'>
						{{ 'GENERIC.reportNotGeneratedYet' | translate }}.
					</span>
					<span *ngIf='reportInformation.recommendationsReport.dates.generated'>
						{{ 'GENERIC.dateReportGenerationOn' | translate }}:
            {{ reportInformation.recommendationsReport.dates.generated }}
            ({{ reportInformation.recommendationsReport.dates.timezone }}).
					</span>
					<span *ngIf='reportInformation.recommendationsReport.dates.refreshed'>
						{{ 'GENERIC.dateReportNextGeneratedOn' | translate }}:
            {{ reportInformation.recommendationsReport.dates.refreshed }}
            ({{ reportInformation.recommendationsReport.dates.timezone }}).
					</span>
				</span>
      </ng-container>
    </small>
  </div>

  <!-- Report Side Nav -->
  <mat-sidenav-container class='report-sidenav-parent' (backdropClick)='closeResolveAlertSideNav()' fxFlex>
    <mat-sidenav
      #sidenav
      class='mvr-side-nav'
      (keydown.escape)='closeResolveAlertSideNav()'
      disableClose
      position='end'
      [autoFocus]='false'
      [opened]='rptService.showReportSideNav'
    >
      <div *ngIf='rptService.selectedRows[0]' fxLayout='column' fxFill>
        <div fxFlex='7' fxLayout='row'>
          <div fxLayoutAlign='start center' class='report-sidenav-title-parent'>
            <span class='report-sidenav-title'>{{ rptService.reportSideNavTitle | uppercase }}</span>
          </div>
          <div fxLayoutAlign='center center' class='report-sidenav-close-btn'>
            <mat-icon
              (click)='closeResolveAlertSideNav()'
              class='report-sidenav-close-icon'
              aria-hidden='false'
              aria-label='close report side navigation'
            >
              close
            </mat-icon>
          </div>
        </div>
        <vrm-resolve-alert *ngIf='rptService.activeReportSideNavContent === rptService.reportSideNavContents.alerts'></vrm-resolve-alert>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div fxLayout='column' fxFlex>
        <!-- Server side filters -->
        <server-side-filter *ngIf='predefinedFiltersService.hasFilters'></server-side-filter>

        <!-- Custom Grid's right pane controls -->
        <div fxLayout='row' fxLayoutAlign='end' class='ag-grid-shaded-background'>
          <div
            class='custom-grid-pane-controls'
            fxLayout='row'
            *ngIf='!rptService.showReportSideNav'
            [class.custom-grid-pane-controls-mobile]='cService.isMobileViewport'
          >
            <div style='width: 1px; background-color: #ccc'></div>

            <!-- Controls -->
            <div fxLayout='row'>
              <button
                mat-icon-button
                (click)='toggleGridToolPane()'
                [matTooltip]="'MESSAGESANDWARNINGS.closeGridControlPane' | translate"
              >
                <mat-icon
                  *ngIf='!cService.selectedLanguage.isRtl'
                  class='rotate-item'
                  [class.right]='gridToolPaneShowing'
                  style='position: relative; bottom: 4px'
                >
                  chevron_left
                </mat-icon>

                <mat-icon
                  *ngIf='cService.selectedLanguage.isRtl'
                  class='rotate-item'
                  [class.right]='gridToolPaneShowing'
                  style='position: relative; bottom: 4px'
                >
                  chevron_right
                </mat-icon>
              </button>

              <button
                mat-button
                fxFlex
                vrm-color
                class='sharp-corners padding-non force'
                *ngIf='rptService.persistedStateChanged && !cService.isMobileViewport'
                (click)='saveOrPersistCurrentStateAsDefault()'
              >
								<span style='position: relative; bottom: 3px'>
									<mat-icon style='position: relative; top: 7px'>save</mat-icon>
                  {{ 'GENERIC.currentStateAsDefault' | translate }}
								</span>
              </button>

              <button
                mat-icon-button
                vrm-color
                class='sharp-corners padding-non force'
                [matTooltip]="'GENERIC.currentStateAsDefault' | translate"
                *ngIf='rptService.persistedStateChanged && cService.isMobileViewport'
                (click)='saveOrPersistCurrentStateAsDefault()'
              >
                <mat-icon style='position: relative; top: -5px'>save</mat-icon>
              </button>

              <button
                mat-button
                fxFlex
                vrm-color
                class='sharp-corners padding-non force'
                *ngIf='
									!rptService.persistedStateChanged &&
									rptService.gridStateDifferentFromDefault &&
									!cService.isMobileViewport
								'
                (click)='resetReportState()'
              >
								<span style='position: relative; bottom: 3px'>
									<mat-icon style='position: relative; top: 7px'>restore_page</mat-icon>
                  {{ 'GENERIC.resetGridState' | translate }}
								</span>
              </button>

              <button
                mat-icon-button
                vrm-color
                class='sharp-corners padding-non force'
                [matTooltip]="'GENERIC.resetGridState' | translate"
                *ngIf='
									!rptService.persistedStateChanged &&
									rptService.gridStateDifferentFromDefault &&
									cService.isMobileViewport
								'
                (click)='resetReportState()'
              >
                <mat-icon style='position: relative; top: -5px'>restore_page</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Grid | TODO: [getContextMenuItems]="customAgGridContextMenuItems" -->
        <ag-grid-angular
          #agGrid
          fxFlex
          [class.visibility-hidden]='
						(!serverSideRendering?.useServerSideRendering && !showRenderedGrid) || !metadata
					'
          class='ag-theme-balham'
          [rowData]='serverSideRendering ? null : rawData'
          [columnDefs]='columnsToDisplay'
          [pinnedTopRowData]='pinnedTopRowData'
          [pinnedBottomRowData]='pinnedBottomRowData'
          [sideBar]='sideBar'
          [gridOptions]='gridOptions'
          [masterDetail]='detailGridConfig.masterDetail'
          [detailCellRendererParams]='detailGridConfig.detailGridRendererParams'
          [defaultExcelExportParams]='detailGridConfig.detailExcelExportParams'
          [isRowMaster]='canRowExpandToShowDetailGrid'
          (gridReady)='agGridReady($event)'
          (rowDataUpdated)='rowDataChanged()'
          (columnResized)='gridColumnResized()'
          (cellDoubleClicked)='cellDoubleClicked($event)'
          (selectionChanged)='getRowSelection($event)'
          (sortChanged)='gridSortChanged()'
          (filterModified)='gridColumnFilterModified()'
          (filterChanged)='gridColumnFilterChanged()'
          (columnVisible)='gridVisibleColumnsToggled()'
          [components]='customComponents'
          [cacheBlockSize]='serverSideRendering ? serverSideRendering.rowsPerPage : null'
        >
        </ag-grid-angular>
      </div>

      <!-- Floating row selection manager -->
      <div
        class='badge-and-floating-button-container point-8-opacity'
        style='z-index: 1'
        *ngIf='
					canDrilldownToDriverPerformanceRecord &&
					(rptService.selectedRows.length || rptService.persistedStateChanged)
				'
      >
        <button
          mat-mini-fab
          type='button'
          [matMenuTriggerFor]='tableSelectionMenu'
          vrm-raised-button
          class='floating-option'
          cdkDrag
          style='cursor: move'
          *ngIf='!rptService.showReportSideNav'
        >
					<span class='manual-badge' *ngIf='rptService.selectedRows.length > 0'>
						{{ rptService.selectedRows.length }}
					</span>
          <mat-icon aria-label='Table Options'>more_vert</mat-icon>
        </button>
        <mat-menu #tableSelectionMenu [overlapTrigger]='false'>
          <!-- Selected row options -->
          <button
            type='button'
            mat-menu-item
            (click)='makeSelectedRowEditableViaDialog()'
            [disabled]='rptService.selectedRows.length === 0'
            *ngIf='rptService.selectedRows.length > 0'
          >
            <mat-icon *ngIf='rptService.selectedRows.length > 0' color='primary'>create</mat-icon>
            <mat-icon *ngIf='rptService.selectedRows.length === 0' class='vrm-disabled force'
            >create
            </mat-icon
            >
            {{ 'GENERIC.manageSelectedData' | translate }}
          </button>

          <button
            type='button'
            mat-menu-item
            (click)='clearRowSelections()'
            [disabled]='rptService.selectedRows.length === 0'
            *ngIf='rptService.selectedRows.length > 0'
          >
            <mat-icon [style.color]="rptService.selectedRows.length > 0 ? 'red' : ''">clear_all</mat-icon>
            {{ 'GENERIC.clearSelection' | translate }}
          </button>

          <button
            type='button'
            mat-menu-item
            (click)='onDeleteElement()'
            [disabled]='rptService.selectedRows.length === 0'
            *ngIf='rptService.selectedRows.length > 0 && canDelete'
          >
            <mat-icon [style.color]="rptService.selectedRows.length > 0 ? 'red' : ''"
            >delete_forever
            </mat-icon
            >
            {{ 'GENERIC.deleteSelected' | translate }}
          </button>

          <!-- Other report related prompts -->
          <button
            type='button'
            mat-menu-item
            *ngIf='rptService.persistedStateChanged'
            (click)='saveOrPersistCurrentStateAsDefault()'
          >
            <mat-icon color='primary'>save</mat-icon>
            {{ 'GENERIC.currentStateAsDefault' | translate }}
          </button>
        </mat-menu>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
